var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 15,
    viewBox: "0 0 28 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.8516,
    y: 1.07031,
    width: 2.45498,
    height: 14.7299,
    rx: 1.22749,
    transform: "rotate(45 17.8516 1.07031)",
    fill: "#C7C7C7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.43555,
    y: 2.80664,
    width: 2.45498,
    height: 14.7299,
    rx: 1.22749,
    transform: "rotate(-45 7.43555 2.80664)",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitBtn);
export default __webpack_public_path__ + "static/media/exit-btn.36d80871cf243b2be2f641a858c5bd86.svg";
export { ForwardRef as ReactComponent };